import * as React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import ProfilePage from './pages/profile/ProfilePage';
import UserListingPage from './pages/users/UserListingPage';
import { OrganizationPage } from './pages/organization/OrganizationPage';
import ErrorPage from './pages/error/ErrorPage';
import ConfirmPasswordResetPage from './pages/confirm/ConfirmPasswordResetPage';
import InsufficientPermissionPage from './pages/error/InsufficientPermissionPage';
import ConfirmNewEmailPage from './pages/confirm/ConfirmNewEmailPage';
import RequestCreateUserPage from './pages/request/RequestCreateUserPage';
import ConfirmCreateUserPage from './pages/confirm/ConfirmCreateUserPage';
import { StartSurveyAnswerPage } from './pages/StartSurveyAnswerPage';
import { SurveyAnswerPage } from './pages/SurveyAnswerPage';
import AmorgAdminSites from './pages/amorgAdmin/AmorgAdminSites';
import { UserLandingPage } from './pages/UserLandingPage';
import { SurveyReportPublicPage } from './pages/SurveyReportPublicPage';
import { DesignSystem } from './pages/dev/DesignSystem';
import LoginPage from './pages/LoginPage';
import LogoutPage from './pages/LogoutPage';
import RequestPasswordResetPage from './pages/request/RequestPasswordResetPage';
import UserPage from './pages/users/[userId]/UserPage';
import { useEffect } from 'react';
import { AmorgAdminLogin } from './pages/amorgAdmin/AmorgAdminLogin';
import AmorgAdminGlobalTemplates from './pages/amorgAdmin/AmorgAdminGlobalTemplates';
import { AmorgAdminImportTemplate } from './pages/amorgAdmin/AmorgAdminImportTemplate';
import { AmorgAdminEditTemplate } from './pages/amorgAdmin/AmorgAdminEditTemplate';
import AmorgAdminUsers from './pages/amorgAdmin/AmorgAdminUsers';
import { AmorgAdminProfile } from './pages/amorgAdmin/AmorgAdminProfile';
import AmorgAdminSiteLogin from './pages/amorgAdmin/AmorgAdminSiteLogin';
import LocationListingPage from './pages/LocationListingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import InspectionPointPage from './pages/InspectionPointPage';
import SafetyInspectionListingPage from './pages/SafetyInspectionListingPage';
import SafetyInspectionPage from './pages/SafetyInspectionPage';
import InspectionPointConfigurationPage from './pages/InspectionPointConfigurationPage';
import WorkplaceAssessmentPage from './pages/WorkplaceAssessmentPage';
import WorkplaceAssessmentListingPage from './pages/WorkplaceAssessmentListingPage';
import WorkgroupMeetingPage from './pages/WorkgroupMeetingPage';
import AnnualWorkgroupStatusPage from './pages/AnnualWorkgroupStatusPage';
import WorkgroupMeetingListingPage from './pages/WorkgroupMeetingListingPage';
import AnnualWorkgroupStatusListingPage from './pages/AnnualWorkgroupStatusListingPage';
import ActionPlanPage from './pages/actionplans/ActionPlanPage';
import DashboardPage from './pages/DashboardPage';
import { CustomFormAnswerPage } from './pages/customForms/[parm]/answers/[parm]/CustomFormAnswerPage';
import { CustomFormPage } from './pages/customForms/[parm]/CustomFormPage';
import { CustomFormReportPage } from './pages/customForms/[parm]/report/CustomFormReportPage';
import { ErgonomicsPage } from './pages/ergonomy/ErgonomicsPage';
import { CustomFormStartAnswerPagePublic } from './pages/customForms/public/CustomFormStartAnswerPagePublic';
import { CustomFormSubmitAnswerPagePublic } from './pages/customForms/public/CustomFormSubmitAnswerPagePublic';
import { NotificationsPage } from './pages/notifications/NotificationsPage';
import ArticlesConfiguration from './pages/amorgAdmin/articles/ArticlesConfiguration';
import ArticlesList from './pages/amorgAdmin/articles/ArticlesList';
import ArticlesSubscriberList from './pages/amorgAdmin/articles/ArticlesSubscriberList';
import ArticlesView from './pages/amorgAdmin/articles/ArticlesView';
import ArticlesSubscriber from './pages/amorgAdmin/articles/ArticlesSubscriber';
import { AmorgAdminLogout } from './pages/amorgAdmin/AmorgAdminLogout';
import { ArticlesOverviewPage } from './pages/articles/ArticlesOverviewPage';
import { ArticleListPage } from './pages/articles/list/ArticleListPage';
import ArticlesFollowUp from './pages/amorgAdmin/articles/ArticlesFollowUp';
import { AmorgAdminSite } from './pages/amorgAdmin/AmorgAdminSite';
import { LearningModuleListPage } from './pages/learning/LearningModuleListPage';
import { LearningModulePage } from './pages/learning/[parms]/LearningModulePage';
import { LearningModuleListPublicPage } from './pages/public/learning/LearningModuleListPublicPage';
import { LearningModulePublicPage } from './pages/public/learning/[parms]/LearningModulePublicPage';
import ArticlesRetsinfoOverviewPage from './pages/amorgAdmin/articles/retsinfo/RetsinfoOverviewPage';
import { ActionPlanListPage } from './pages/actionplans/ActionPlanListPage';
import ActionPlanPublicPage from './pages/actionplans/ActionPlanPublicPage';
import { DummyPage } from './pages/dev/DummyPage';
import RequestPasswordSetupPage from './pages/request/RequestPasswordSetupPage';
import { ExternalLinksOverviewPage } from './pages/externallinks/ExternalLinksOverviewPage';
import { DocumentArchiveOverviewPage } from './pages/documentArchive/DocumentArchiveOverviewPage';
import { ArticlePage } from './pages/articles/[articleId]/ArticlePage';
import { PublicArticlePage } from './pages/articles/public/[articleId]/PublicArticlePage';
import ContactSupportPage from './pages/support/ContactSupportPage';
import { InternalArticleListPage } from './pages/articles/internal/InternalArticleListPage';
import { InternalArticlePage } from './pages/articles/internal/[internalArticleId]/InternalArticlePage';
import { SupportPage } from './pages/SupportPage';
import { ArticlesLightPage } from './pages/articles/ArticlesLightPage';

import { IncidentListPage } from './pages/incidents/IncidentListPage';
import { IncidentReporterPublicPage } from './pages/incidents/public/[siteId]/[id]/IncidentReporterPublicPage';
import { PortalLoginPage } from './pages/portal/login/[siteId]/PortalLoginPage';
import { PortalLoginConfirmPage } from './pages/portal/login/[siteId]/confirm/PortalLoginConfirmPage';
import { PortalHomePage } from './pages/portal/PortalHomePage';
import { PortalIncidentPage } from './pages/portal/incidents/[type]/PortalIncidentPage';
import { PortalLogoutPage } from './pages/portal/PortalLogoutPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { IncidentPage } from './pages/incidents/IncidentPage';
import { applicationEndpoints } from './amorg-common/applicationEndpoints';
import { PortalOrganizationPage } from './pages/portal/organization/PortalOrganizationPage';
import { PortalAccessKeyPage } from './pages/portal/access-key/[siteId]/[accessKey]/PortalAccessKeyPage';
import { PortalFileListPage } from './pages/portal/files/PortalFileListPage';



const ScrollToTop = (props) =>
{
    const location = useLocation();
    useEffect(() =>
    {
        window.scrollTo(0, 0);
    }, [location]);

    return <>{props.children}</>;
};

export function AmorgRoutes (): JSX.Element
{

    return (
        <ScrollToTop>
            <Switch>

                <Route path="/login/:siteId?">
                    <LoginPage />
                </Route>

                <Route path="/logout">
                    <LogoutPage />
                </Route>

                <Route path="/profile">
                    <ProfilePage />
                </Route>

                <Route path="/users/:userId">
                    <UserPage />
                </Route>

                <Route path="/users">
                    <UserListingPage />
                </Route>


                <Route path={applicationEndpoints.organization}>
                    <OrganizationPage />
                </Route>

                <Route path="/actionplans/public/:linkId@:siteId">
                    <ActionPlanPublicPage />
                </Route>

                <Route path="/actionplans/:actionPlanId">
                    <ActionPlanPage />
                </Route>

                <Route path="/actionplans">
                    <ActionPlanListPage />
                </Route>

                <Route path="/annualworkgroupstatus/:activityId">
                    <AnnualWorkgroupStatusPage />
                </Route>

                <Route path="/annualworkgroupstatus">
                    <AnnualWorkgroupStatusListingPage />
                </Route>

                <Route path="/workgroupmeetings/:activityId">
                    <WorkgroupMeetingPage />
                </Route>

                <Route path="/workgroupmeetings">
                    <WorkgroupMeetingListingPage />
                </Route>

                <Route path="/workplaceassessments/:activityId">
                    <WorkplaceAssessmentPage />
                </Route>
                <Route path="/workplaceassessments">
                    <WorkplaceAssessmentListingPage />
                </Route>

                <Route path="/safetyinspections/:activityId/inspections/:facilityInspectionId">
                    <InspectionPointPage />
                </Route>

                <Route path="/safetyinspections/:activityId">
                    <SafetyInspectionPage />
                </Route>

                <Route path="/safetyinspections">
                    <SafetyInspectionListingPage />     
                </Route>

                <Route path="/inspectionpoints">
                    <InspectionPointConfigurationPage />
                </Route>

                <Route path="/locations">
                    <LocationListingPage />
                </Route>

                <Route path="/surveys/publicreport/:linkId@:siteId">
                    <SurveyReportPublicPage />
                </Route>

                <Route path="/surveys/:surveyId@:siteId/answers/:answerId">
                    <SurveyAnswerPage />
                </Route>
                <Route path="/surveys/:surveyId@:siteId">
                    <StartSurveyAnswerPage />
                </Route>

                <Route path="/confirm/resetpassword/:siteId/:userId/:requestId">
                    <ConfirmPasswordResetPage />
                </Route>
                <Route path="/confirm/setuppassword/:siteId/:userId/:requestId">
                    <ConfirmPasswordResetPage />
                </Route>
                <Route path="/request/resetpassword">
                    <RequestPasswordResetPage />
                </Route>
                <Route path="/request/setuppassword">
                    <RequestPasswordSetupPage />
                </Route>
                <Route path="/confirm/newemail/:siteId/:userId/:requestId">
                    <ConfirmNewEmailPage />
                </Route>
                <Route path="/confirm/createuser/:siteId/:userId/:requestId">
                    <ConfirmCreateUserPage />
                </Route>
                <Route path="/request/createuser">
                    <RequestCreateUserPage />
                </Route>

                <Route path="/error">
                    <ErrorPage />
                </Route>
                <Route path="/insufficientpermission">
                    <InsufficientPermissionPage />
                </Route>

                <Route path="/dev/designsystem">
                    <DesignSystem />
                </Route>

                <Route path="/user/overview">
                    <UserLandingPage />
                </Route>

                <Route path="/externallinks">
                    <ExternalLinksOverviewPage />
                </Route>

                <Route path="/documentarchive">
                    <DocumentArchiveOverviewPage />
                </Route>

                <Route path="/notifications">
                    <NotificationsPage />
                </Route>

                <Route path="/dashboard">
                    <DashboardPage />
                </Route>

                <Route path={'/amorgy/login'}>
                    <AmorgAdminLogin />
                </Route>

                <Route path={'/amorgy/logout'}>
                    <AmorgAdminLogout />
                </Route>

                <Route path={'/amorgy/globaltemplates'}>
                    <AmorgAdminGlobalTemplates />
                </Route>

                <Route path={'/amorgy/importtemplate'}>
                    <AmorgAdminImportTemplate />
                </Route>

                <Route path={'/amorgy/edittemplate/:templateId'}>
                    <AmorgAdminEditTemplate />
                </Route>

                <Route path={'/amorgy/users'}>
                    <AmorgAdminUsers />
                </Route>

                <Route path={'/amorgy/profile'}>
                    <AmorgAdminProfile />
                </Route>

                <Route path={'/amorgy/sites/:siteId'}>
                    <AmorgAdminSite />
                </Route>

                <Route path={'/amorgy/sites'}>
                    <AmorgAdminSites />
                </Route>

                <Route path={'/amorgy/sitelogin'}>
                    <AmorgAdminSiteLogin />
                </Route>

                <Route path={'/amorgy/articles/subscribers/:subscriberId'}>
                    <ArticlesSubscriber />
                </Route>

                <Route path={'/amorgy/articles/subscribers'}>
                    <ArticlesSubscriberList />
                </Route>

                <Route path={'/amorgy/articles/configuration'}>
                    <ArticlesConfiguration />
                </Route>

                <Route path={'/amorgy/articles/followup'}>
                    <ArticlesFollowUp />
                </Route>

                <Route path={'/amorgy/articles/retsinfo'}>
                    <ArticlesRetsinfoOverviewPage />
                </Route>

                <Route path={'/amorgy/articles/:id'}>
                    <ArticlesView />
                </Route>

                <Route path={'/amorgy/articles'}>
                    <ArticlesList />
                </Route>

                <Route path={'/amorgy'}>
                    <AmorgAdminSiteLogin />
                </Route>


                <Route path={'/support/contact'}>
                    <ContactSupportPage />
                </Route>

                <Route path={'/support'}>
                    <SupportPage />
                </Route>

                
                <Route path={'/privacy'}>
                    <PrivacyPolicyPage />
                </Route>

                <Route path="/customforms/public/:key@:siteId">
                    <CustomFormStartAnswerPagePublic />
                </Route>

                <Route path="/customforms/public/:siteId/:answerId">
                    <CustomFormSubmitAnswerPagePublic />
                </Route>

                <Route path="/customforms/:formId/answers/:answerId">
                    <CustomFormAnswerPage />
                </Route>

                <Route path="/customforms/:formId/report">
                    <CustomFormReportPage />
                </Route>

                <Route path="/customforms/:activityId">
                    <CustomFormPage />
                </Route>

                <Route path="/ergonomics">
                    <ErgonomicsPage />
                </Route>

                <Route path="/articles/internal/:internalArticleId">
                    <InternalArticlePage />
                </Route>

                <Route path="/articles/summary">
                    <ArticlesLightPage />
                </Route>

                <Route path="/articles/internal">
                    <InternalArticleListPage />
                </Route>

                <Route path="/articles/list">
                    <ArticleListPage />
                </Route>

                <Route path={applicationEndpoints.public_article_siteId_articleId}>
                    <PublicArticlePage  />
                </Route>

                <Route path="/articles/:articleId">
                    <ArticlePage />
                </Route>

                <Route path="/articles">
                    <ArticlesOverviewPage />
                </Route>

                {/*----------------------------------- THESE SHOULD BE REMOVED ONCE NO LONGER NEEDED BEGIN ------------------------------------------ */}
                <Route path="/learning/public/:moduleId">
                    <LearningModulePublicPage />
                </Route>

                <Route path="/learning/public">
                    <LearningModuleListPublicPage />
                </Route>
                {/*----------------------------------- THESE SHOULD BE REMOVED ONCE NO LONGER NEEDED END------------------------------------------ */}



                <Route path="/learning/:moduleId">
                    <LearningModulePage />
                </Route>

                <Route path="/learning">
                    <LearningModuleListPage />
                </Route>

                <Route path={applicationEndpoints.incidents_id}>
                    <IncidentPage />    
                </Route>

                <Route path={applicationEndpoints.incidents}>
                    <IncidentListPage />
                </Route>

                <Route path={applicationEndpoints.public_incidents_siteId_id}>
                    <IncidentReporterPublicPage />
                </Route>


                <Route path={applicationEndpoints.public_learning_moduleId}>
                    <LearningModulePublicPage />
                </Route>

                <Route path={applicationEndpoints.public_learning}>
                    <LearningModuleListPublicPage />
                </Route>


                <Route path="/dev/dummy">
                    <DummyPage />
                </Route>

                <Route path={applicationEndpoints.portal_access_key_siteId_accessKey}>
                    <PortalAccessKeyPage />
                </Route>

                <Route path={applicationEndpoints.portal_login_siteId_confirm_email_requestId}>
                    <PortalLoginConfirmPage />
                </Route>

                <Route path={applicationEndpoints.portal_login_siteId}>
                    <PortalLoginPage />
                </Route>

                <Route path={applicationEndpoints.portal_login}>
                    <PortalLoginPage />
                </Route>

                <Route path={applicationEndpoints.portal_logout}>
                    <PortalLogoutPage />
                </Route>

                <Route path={applicationEndpoints.portal_organization}>
                    <PortalOrganizationPage />
                </Route>

                <Route path={applicationEndpoints.portal_files}>
                    <PortalFileListPage />
                </Route>

                <Route path={applicationEndpoints.portal_incidents_type}>
                    <PortalIncidentPage />
                </Route>

                <Route path={applicationEndpoints.portal}>
                    <PortalHomePage />
                </Route>

                <Route path={applicationEndpoints.settings}>
                    <SettingsPage />
                </Route>

                <Route path={applicationEndpoints.dashboard}>
                    <DashboardPage />
                </Route>

            </Switch>
        </ScrollToTop>
    );
}